// @flow
import React, { useContext } from 'react';

import {
  IS_NATIVE_INFERENCE_CCU_LIVE_IN_CE1,
  NATIVE_INFERENCE_POOL_PRICING_SUMMARY,
} from '../../../constants';
import { getPlainObjectFromBackEndSpendSummaryFormat } from '../../../common-utils/utils';
import { NativeInferencePoolContext } from '../../../contexts/NativeInferencePoolContext';
import { TotalSpendSummaryContainer } from '../../common/TotalSpendSummaryContainer';

export const NativeInferencePoolTotalSpendSummaryContainer = ({ disabled }) => {
  const nativeInferencePoolDetails = useContext(NativeInferencePoolContext);
  const inputDataSource = nativeInferencePoolDetails.spend_summary;
  // The ordering list doubles as an allowlist: rows not in it are dropped from the grid.
  const orderingOfRows = IS_NATIVE_INFERENCE_CCU_LIVE_IN_CE1
    ? ['CCU', 'Models', 'Total']
    : ['Models', 'Total'];
  const inputDataSourceFormattedAndOrdered = getPlainObjectFromBackEndSpendSummaryFormat(
    inputDataSource,
    orderingOfRows
  );

  return (
    <TotalSpendSummaryContainer
      disabled={disabled}
      gridLabel={NATIVE_INFERENCE_POOL_PRICING_SUMMARY}
      inputDataSourceFormattedAndOrdered={inputDataSourceFormattedAndOrdered}
      removeTotalBannerRow={true}
      removeZeroRows={false}
    />
  );
};
